import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import { bridgeProductManagementApp } from './';

let prevState = sessionStorage.getItem("ProductManagementReactApp");

// Create store
const store = createStore(
    bridgeProductManagementApp,

    prevState ? JSON.parse(prevState) : {},

    // Initialize cr
    composeWithDevTools(
        applyMiddleware(
            // Setup library to help with async actions
            thunkMiddleware,
            // Setup console action logger middleware
            createLogger()
        )
    )
);

export default store;